"use client";

import { useParams } from "next/navigation";
import { FC } from "react"

const PrivacyPortugueseClient: FC = () => {
  const { locale } = useParams();

  return (
    <div className="flex flex-col bg-black-900 px-9 py-8 gap-4 rounded-2xl items-start">
      <h4 className="text-title-lg">Política de Privacidade.</h4>

      <p>
        Data de entrada em vigor: 01 de março de 2024.
      </p>

      <p>
        Arena Pro Gaming, cuja aparição neste acordo se fará doravante como &quot;nós&quot;, opera o site <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, doravante mencionado como &quot;site&quot;.
      </p>

      <p>
        Nós como organização valorizamos e respeitamos a privacidade dos usuários do nosso site, reconhecendo-os como profissionais membros da comunidade de videogames e eSports e nos comprometemos a proteger a informação pessoal que você como usuário nos fornece. Esta <strong>política de privacidade</strong> estabelece como coletamos, utilizamos, divulgamos e protegemos sua informação pessoal.
      </p>

      <h4 className="text-title-md">1. Informação pessoal coletada.</h4>

      <p>
        Podemos coletar a seguinte informação pessoal dos usuários do nosso site:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Nome completo.
        </li>
        <li>
          ii. Endereço de e-mail.
        </li>
        <li>
          iii. Informação de contato (como endereço, número de telefone, etc.)
        </li>
        <li>
          iv. Informação profissional (como experiência laboral, habilidades, etc.)
        </li>
        <li>
          v. Localização (país de residência ou de origem)
        </li>
        <li>
          vi. Preferências de videogames.
        </li>
        <li>
          vii. Informação de eventos (futuros ou passados).
        </li>
        <li>
          viii. Informação sobre equipamento usado para realizar suas atividades profissionais ou que tenham relação com os roles escolhidos.
        </li>
        <li>
          ix. Imagens subidas ou compartilhadas no site.
        </li>
      </ul>

      <h4 className="text-title-md">2. Uso da informação pessoal.</h4>

      <p>
        Utilizamos a informação pessoal coletada para os seguintes propósitos:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Fornecer e manter nosso site e seus serviços.
        </li>
        <li>
          ii. Comunicar-nos com você e responder a suas consultas e solicitações.
        </li>
        <li>
          iii. Personalizar sua experiência em nosso site e oferecer-lhe conteúdo relevante.
        </li>
        <li>
          iv. Melhorar nossos serviços e realizar análises e estudos de mercado.
        </li>
        <li>
          v. Cumprir com as leis e regulamentações aplicáveis.
        </li>
        <li>
          vi. Nutrir nossa ferramenta de busca para mostrar poder mostrar os perfis e informação de interesse de maneira precisa.
        </li>
        <li>
          vii. Criar futuras ferramentas que ajudem a comunidade de videogames e eSports.
        </li>
      </ul>

      <h4 className="text-title-md">3. Divulgação da informação pessoal.</h4>

      <p>
        Podemos compartilhar sua informação pessoal com terceiros nas seguintes circunstâncias:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Provedores de serviços: Podemos compartilhar sua informação pessoal com provedores de serviços externos que nos ajudam a operar nosso site e fornecer-lhe nossos serviços.
        </li>
        <li>
          ii. Cumprimento legal: Podemos divulgar sua informação pessoal se assim o exige a lei ou se acreditamos de boa fé que tal divulgação é necessária para cumprir com um procedimento legal em curso, proteger nossos direitos ou responder a uma solicitação legal válida.
        </li>
      </ul>

      <h4 className="text-title-md">4. Segurança da informação pessoal.</h4>

      <p>
        Nos comprometemos a proteger a segurança da sua informação pessoal. Implementamos medidas de segurança técnicas, administrativas e físicas para proteger sua informação contra o acesso não autorizado, a divulgação ou o uso indevido.
      </p>

      <h4 className="text-title-md">5. Retenção da informação pessoal.</h4>

      <p>
        Manteremos sua informação pessoal apenas durante o tempo necessário para cumprir com os fins estabelecidos nesta <strong>política de privacidade</strong>, a menos que se
        requeira ou permita um período de retenção mais longo por lei.
      </p>

      <h4 className="text-title-md">6. Direitos do usuário.</h4>

      <p>
        Você tem certos  direitos com respeito à informação pessoal que fornece neste site  web, incluindo o direito de acessar, corrigir, eliminar e limitar o processamento da sua informação pessoal. Você pode exercer estes direitos facilmente  desde nosso site web ou comunicando-se connosco através dos dados de contacto fornecidos ao final deste acordo.
      </p>

      <h4 className="text-title-md">7. Mudanças na política  de privacidade.</h4>

      <p>
        Reservamo-nos o direito de modificar esta <strong>política de privacidade</strong> em qualquer momento. Qualquer mudança entrará em vigor imediatamente após a sua publicação no nosso site web. Recomendamos que você revise periodicamente esta <strong>política de privacidade</strong> para estar informado sobre qualquer mudança.
      </p>

      <p>
        Se você tiver alguma pergunta, dúvida ou preocupação sobre nossa <strong>política de privacidade</strong> ou sobre como gerenciamos sua informação pessoal, não hesite em se comunicar conosco através  dos seguintes dados de contacto:
      </p>

      <p>
        Arena Pro Gaming. 2024, todos os direitos reservados.
      </p>

      <p>
        Correio electrónico: <a className="text-aqua-300" href="mailto:hola@apg.gg">hola@apg.gg</a>
      </p>

      <p>
        Discord: <a className="text-aqua-300" href="https://discord.gg/6ja3zj9XyR">https://discord.gg/6ja3zj9XyR</a>
      </p>

      <p>
        Twitter: <a className="text-aqua-300" href="https://twitter.com/apg_club">@apg_club</a>
      </p>
    </div>
  )
}

export default PrivacyPortugueseClient